/**
 * Estado administrativo de um webchat — o freio que o **dono não controla**.
 *
 * Mora no engine porque servidor e painel precisam da mesma leitura: o servidor para recusar a config, o
 * painel para explicar ao dono por que o widget dele parou.
 *
 * ## Por que não bastavam os tetos
 *
 * `conversationLimit` e `requestLimit` são **auto-serviço**: o dono edita os dele mesmo. Isso é correto
 * para o que eles são — freio de gasto escolhido por quem paga a conta — e inútil como cobrança. Um site
 * que instalou o SDK e parou de pagar simplesmente aumenta o próprio teto.
 *
 * Daí este campo. Ele fica na raiz do documento e entra em `serverFieldsUnchanged()` nas Rules, junto de
 * `published` e `secretNames` — nenhum cliente escreve, nem o dono. É o que faz a suspensão valer.
 *
 * ## Ausente e desconhecido valem **ativo**, de propósito
 *
 * Falha para o lado de deixar funcionando. O raciocínio: só o servidor escreve aqui, então valor
 * estranho neste campo é defeito nosso, não abuso do cliente. E as duas falhas não custam igual —
 * derrubar o widget de todos os clientes cujo campo foi mal gravado é muito pior que um cliente suspenso
 * seguir atendendo até alguém consertar o valor.
 *
 * Se um dia o campo passar a ser escrito por webhook de cobrança, esta decisão merece ser reavaliada:
 * com escrita automática, valor inesperado deixa de ser só defeito nosso.
 */
/** Normaliza o que veio do documento. Qualquer coisa que não seja `suspended` conta como ativo. */
export function resolveWebchatStatus(value) {
    return value === 'suspended' ? 'suspended' : 'active';
}
/** Atalho para o caminho quente, onde a pergunta é sempre esta. */
export function isSuspended(value) {
    return resolveWebchatStatus(value) === 'suspended';
}
//# sourceMappingURL=status.js.map